// extracted by mini-css-extract-plugin
module.exports = {"popupWrapper":"alerts_popupWrapper__18KXW","notificationBG":"alerts_notificationBG__b5nyx"};